import { ClaimRequest } from '../../../domain/entities';
import { ClaimRequestDto } from '../dtos/ClaimRequestDto';
import { toDomain as claimRequestDtoToDomain } from '../../ClaimRequestMapper';
import { CollectionEntityResponse, flattenEntity, OperationMethod, processFetchOperation } from '../../api';
import { dateFormatter } from '../../../ui/utils/DateUtils';

export class DuplicatedInvoiceRepository {
    findInvoiceRelatedClaimRequests(taxIdNumber: string, number: string, date: Date): Promise<ClaimRequest[]> {
        return processFetchOperation(`/v1/invoices/related-claims`, OperationMethod.GET, {
            params: { taxIdNumber: taxIdNumber, number: number, date: dateFormatter(date) },
        }).then((dtos: CollectionEntityResponse<ClaimRequestDto>) => {
            const entities = dtos.data.map((it) => {
                return flattenEntity(it, dtos.included || []);
            });
            return entities.map((it) => claimRequestDtoToDomain(it));
        });
    }
}

